/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1PersonPersonidResumeeExamsQueryResponse,
  GetApiV1PersonPersonidResumeeExamsPathParams,
  GetApiV1PersonPersonidResumeeExams400,
  GetApiV1PersonPersonidResumeeExams401,
  GetApiV1PersonPersonidResumeeExams500,
} from "../../types/personResumeeController/GetApiV1PersonPersonidResumeeExams.ts";

function getGetApiV1PersonPersonidResumeeExamsUrl(
  personId: GetApiV1PersonPersonidResumeeExamsPathParams["personId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/person/${personId}/resumee/exams` as const,
  };
  return res;
}

/**
 * @description Retorna os dados em comum e a lista de avaliações da pessoa **(Requer Authorization para autenticação)**
 * @summary Retorna aba de Avaliações do currículo (Requer Authorization para autenticação)
 * {@link /api/v1/person/:personId/resumee/exams}
 */
export async function getApiV1PersonPersonidResumeeExams(
  personId: GetApiV1PersonPersonidResumeeExamsPathParams["personId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1PersonPersonidResumeeExamsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonPersonidResumeeExams400
      | GetApiV1PersonPersonidResumeeExams401
      | GetApiV1PersonPersonidResumeeExams500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1PersonPersonidResumeeExamsUrl(personId).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
